<template>
  <md-cell-item
    :title="model.tradeType.description"
    :brief="model.status.description"
    no-border
    :class="['cell-border__exclude-45' ,'order-item', amountClass]"
    @click="handleToDetail"
  >
    <div slot="right" class="amount-info">
      <span class="amount-value">{{ amountView }}</span>
      <span class="payment-time">{{ model.tradeTime | formatTimestamp }}</span>
    </div>
  </md-cell-item>
</template>

<script>
import { CellItem } from 'mand-mobile'
// import { TRADE_TYPE, ACCOUNT_TYPE } from '@/constants'
import { TRADE_TYPE } from '@/constants'
import { fenToYanAndFormat } from '@/utils/format-amount'
import formatTimestamp from '@/utils/format-timestamp'

export default {
  name: 'OrderItem',

  components: {
    [CellItem.name]: CellItem
  },

  filters: {
    formatTimestamp (val) {
      return formatTimestamp(val, 'dd/MM hh:mm')
    }
  },

  props: {
    // 订单数据
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    amountClass () {
      if (this.model.tradeType.code === TRADE_TYPE.RECHARGE) {
        return 'increase'
      }

      return 'cut'
    },

    amountView () {
      const amount = fenToYanAndFormat(this.model.amount)
      if (this.model.tradeType.code === TRADE_TYPE.RECHARGE) {
        return `+Rp${amount}`
      }

      return `-Rp${amount}`
    }
  },

  methods: {
    handleToDetail () {
      // const { tradeNo, payeeAccountType } = this.model
      const { tradeNo } = this.model
      const tradeType = this.model.tradeType.code
      const route = { query: { tradeNo: tradeNo, isHistory: true } }

      switch (tradeType) {
        // 提现
        case TRADE_TYPE.WITHDRAW:
          route.name = 'HaveStepsDetail'
          break

        // 充值
        case TRADE_TYPE.RECHARGE:
          route.name = 'HaveNoStepsDetail'
          break

          // 转账（产品说是实时的，统一为不带步骤条的）
        case TRADE_TYPE.TRANSFER:
          route.name = 'HaveNoStepsDetail'
          // 如果为银行账号
          // if (payeeAccountType === ACCOUNT_TYPE.BANK_ACCOUNT) {
          //   route.name = 'HaveStepsDetail'
          // }

          // // 如果为手机号账户
          // if (payeeAccountType === ACCOUNT_TYPE.WALLET_TYPE) {
          //   route.name = 'HaveNoStepsDetail'
          // }
          break

        // 消费
        case TRADE_TYPE.CONSUME:
          route.name = 'HaveNoStepsDetail'
          break
      }
      this.$router.push(route)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-item::v-deep {
  position: relative;

  .amount-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    height: 100%;

    .amount-value {
      font-size: 24px;
    }

    .payment-time {
      margin-top: 12px;
      font-size: 24px;
      color: #b2b2b2;
    }
  }

  // 增加
  &.increase {
    .amount-value {
      color: #333;
    }

    &::before {
      background: linear-gradient(0deg, #c37ffe, #db98fe);
    }
  }

  &.cut {
    .amount-value {
      color: #7f7f7f;
    }

    &::before {
      background: linear-gradient(180deg, #33d3c5, #0ed2bf);
    }
  }

  &::before {
    position: absolute;
    content: '';
    display: block;
    top: 22px;
    left: 0;
    height: 100px;
    width: 12px;
    z-index: 10;
    border-radius: 0 200px 200px 0;
  }

  .md-cell-item-content {
    margin-left: 48px;
  }

  .md-cell-item-title {
    font-size: 28px;
    color: #333;
  }

  .md-cell-item-brief {
    font-size: 24px;
    color: #b2b2b2;
  }
}

.order-icon {
  display: block;
  height: 76px;
  width: 76px;
  border-radius: 8px;
}
</style>
